/**
 * @file
 * Back to Top button behavior
 * 
 * Adapted from MDBootstrap pattern:
 * https://mdbootstrap.com/docs/standard/extended/back-to-top/
 */

(function (Drupal, once) {
    'use strict';
  
    Drupal.behaviors.backToTop = {
      attach: function (context, settings) {
        // Use 'once' to ensure we only attach once per element
        // Similar to getElementById but works with Drupal's component system
        const buttons = once('back-to-top', '.back-to-top', context);
        
        buttons.forEach(function(mybutton) {
          // Get scroll threshold from data attribute (default to 300px)
          // MDBootstrap uses hardcoded 20px, we make it configurable
          const scrollThreshold = parseInt(mybutton.dataset.scrollThreshold) || 300;
          
          /**
           * Scroll detection function
           * Same logic as MDBootstrap snippet
           */
          function scrollFunction() {
            // Check both scrollTop properties for browser compatibility
            // (Same as MDBootstrap: Safari uses body.scrollTop, others use documentElement.scrollTop)
            if (
              document.body.scrollTop > scrollThreshold ||
              document.documentElement.scrollTop > scrollThreshold
            ) {
              // Show button - remove hidden class instead of inline style
              // This allows CSS transitions (fade in/out)
              mybutton.classList.remove('back-to-top--hidden');
            } else {
              // Hide button
              mybutton.classList.add('back-to-top--hidden');
            }
          }
          
          /**
           * Scroll to top function
           * Enhanced from MDBootstrap with smooth scroll
           */
          function backToTop() {
            // MDBootstrap version (instant scroll):
            // document.body.scrollTop = 0;
            // document.documentElement.scrollTop = 0;
            
            // Enhanced version with smooth scroll:
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            
            // Optional: Accessibility improvement (focus management)
            setTimeout(function() {
              const mainContent = document.querySelector('#main-content') || 
                                 document.querySelector('main');
              if (mainContent) {
                mainContent.setAttribute('tabindex', '-1');
                mainContent.focus();
                mainContent.addEventListener('blur', function() {
                  mainContent.removeAttribute('tabindex');
                }, { once: true });
              }
            }, 500);
          }
          
          // Attach scroll event listener
          // MDBootstrap uses window.onscroll (can be overwritten)
          // We use addEventListener (safer, allows multiple listeners)
          window.addEventListener('scroll', scrollFunction, { passive: true });
          
          // Attach click event listener (same as MDBootstrap)
          mybutton.addEventListener('click', backToTop);
          
          // Initial check on page load
          scrollFunction();
        });
      }
    };
  })(Drupal, once);